import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBan,
  faBoxArchive,
  faCircleCheck,
  faCircleExclamation,
  faCircleXmark,
  faClipboardList,
  faComments,
  faHourglassHalf,
  faLayerGroup,
  faShieldHalved,
  faTableColumns,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

type SideBarItem = {
  label: string;
  route: string;
  icon: IconDefinition;
  activeIcon: string;
  subData?: { label: string; route: string }[];
};

const SideBarData: SideBarItem[] = [
  {
    label: "Dashboard",
    route: "/",
    icon: faTableColumns,
    activeIcon: "",
  },
  {
    label: "Chase List",
    route: "/chaselist",
    icon: faLayerGroup,
    activeIcon: "",
  },
  {
    label: "Awaiting Customer",
    route: "/chase/Awaiting-Customer",
    icon: faHourglassHalf,
    activeIcon: "",
  },
  {
    label: "Pending Review",
    route: "/chase/Pending-Review",
    icon: faClipboardList,
    activeIcon: "",
  },
  {
    label: "Rejected",
    route: "/chase/Rejected",
    icon: faCircleExclamation,
    activeIcon: "",
  },
  {
    label: "Approved",
    route: "/chase/Approved",
    icon: faCircleCheck,
    activeIcon: "",
  },
  {
    label: "Failed",
    route: "/chase/Failed",
    icon: faCircleXmark,
    activeIcon: "",
  },
  {
    label: "Actioned",
    route: "/chase/Actioned",
    icon: faBan,
    activeIcon: "",
    subData: [],
  },
  {
    label: "Customer Archives",
    route: "/customer-archives",
    icon: faBoxArchive,
    activeIcon: "",
  },
  {
    label: "My Customers",
    route: "/my-customers",
    icon: faUsers,
    activeIcon: "",
  },
  {
    label: "Chats",
    route: "/chat",
    icon: faComments,
    activeIcon: "",
  },
  {
    label: "Agents",
    route: "/agents",
    icon: faUser,
    activeIcon: "",
  },
  {
    label: "Insurer Rules",
    route: "/providers",
    icon: faShieldHalved,
    activeIcon: "",
  },
];

export default SideBarData;
